var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-orange animated slideInLeft faster"},[_c('div',{attrs:{"id":"lottie"}},[_c('canvas',{attrs:{"id":"canvas"}})])])}]

export { render, staticRenderFns }